module.exports = __webpack_public_path__ + "sgby/img/default-slide.13487dd.png";